import { render, staticRenderFns } from "./ot-claim-suspension-dialog.vue?vue&type=template&id=080785a2&scoped=true&"
import script from "./ot-claim-suspension-dialog.vue?vue&type=script&lang=ts&"
export * from "./ot-claim-suspension-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./ot-claim-suspension-dialog.vue?vue&type=style&index=0&id=080785a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080785a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
